<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Level</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name"  />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <ckeditor
                                        :editor="editor"
                                        v-model="level.description"
                                        :config="editorConfig"
                                ></ckeditor>
                                <validation-error :errors="apiValidationErrors.description" />
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Exam ID
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.exam_id" />
                                    <validation-error :errors="apiValidationErrors.exam_id"  />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Level For
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="level.level_for" name="active">
                                        <md-option value="necta">Necta</md-option>
                                        <md-option value="nacte">Nacte</md-option>
                                        <md-option value="tcu">tcu</md-option>
                                        <md-option value="veta">veta</md-option>
                                        <md-option value="tra">tra</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.level_for" />
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Active
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="level.active" name="active">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.active" />
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Update</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
    components: { ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
        level: {
            type:'levels',
            name:null,
            short_name:null,
            description: null,
            exam_id:null,
            level_for: null,
            active: null,
        },
    }),

    created () {
        this.get();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('levels/get', id);
                this.level = this.$store.getters['levels/level'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('levels/update', this.attachmentType);
                await this.$store.dispatch(
                    'alerts/success',
                    'Level updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Levels List' });
        },
    },
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

    .md-checkbox {
        margin-top: 15px !important;
    }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style >
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>


